import PaywallModal from 'components/modals/PaywallModal';
import usePreferences from 'hooks/usePreferences';
import posthog from 'posthog-js';
import Keys from 'preferences/preferences';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';
import { selectDoesUserHaveFullAccess } from 'store/users/selectors';

/**
 * « Démarrer ma conversation »: opens the new conversation, or the paywall
 * first when the patient has neither full access nor her free messages yet.
 * Render `paywall` next to the button.
 */
export default function useStartConversation(source: string) {
  const navigate = useNavigate();
  const [isPaywallOpen, setIsPaywallOpen] = useState(false);
  const doesUserHaveFullAccess = useSelector(selectDoesUserHaveFullAccess);
  const { value: didEnableFreeMessagesValue, set: setDidEnableFreeMessages } = usePreferences(
    Keys.PAYWALL_DID_ENABLE_FREE_MESSAGES,
  );

  const openNewConversation = () => navigate(routes.newChat.route);

  const startConversation = () => {
    if (doesUserHaveFullAccess || didEnableFreeMessagesValue === true) {
      posthog.capture('chats.start_conversation_clicked', { source });
      openNewConversation();
    } else {
      posthog.capture('paywall.opened', { source });
      setIsPaywallOpen(true);
    }
  };

  const paywall = (
    <PaywallModal
      isOpen={isPaywallOpen}
      onClose={() => setIsPaywallOpen(false)}
      // The call to action of its success screens (free test enabled, or paid): the patient can now write
      closeModal={() => {
        setIsPaywallOpen(false);
        openNewConversation();
      }}
      onFreeMessagesEnabled={() => setDidEnableFreeMessages('true')}
    />
  );

  return { startConversation, paywall };
}
